import { get } from "lodash-es";
import axios from "axios";

export default {
  state: {
    avls: [],
    avlForModify: null,
  },
  mutations: {
    setAvls(state, payload) {
      state.avls = payload;
    },
    setAvlForModify(state, payload) {
      state.avlForModify = payload;
    },
  },
  actions: {
    async getAvls(context) {
      const resp = await axios.post("/execute", {
        method: "CLI.GetAvlsSinContratos",
        parameters: [],
      });
      if (resp.data.ok) {
        const avls = get(resp, "data.result[0]");
        context.commit("setAvls", avls);
      }

      return resp.data;
    },
  },
  getters: {
    getAvls(state) {
      return state.avls;
    },
  },
};
